module.exports = __webpack_public_path__ + "img/img_intelligence_cultivate_village@3x.570100aa.png";